import React from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'app/middleware/hooks';

import LOGO from 'static/img/Tourstart_Logo.svg';
import LOGO_PICT from '../../../../static/img/logo_tourstart_42.png';

function MainLogo({ handleLogoClick }) {
  const mainLogo = isMobile(1024) ? LOGO_PICT : LOGO;
  return (
    <div className="logo" onClick={handleLogoClick} aria-hidden>
      <img src={mainLogo} alt="logo" style={{ cursor: 'pointer' }} />
    </div>
  );
}

MainLogo.displayName = 'MainLogo';
MainLogo.propTypes = {
  handleLogoClick: PropTypes.func,
};

export default MainLogo;
